export default __webpack_public_path__ + "3e3826616c156f9d249ffe14ab89dd42.woff2";